<div class="product__grc">
  <div class="products-grc__container">
    <section class="products__grc-section-hero">
      <app-hero-section [routerButton]="routerHeroButton" [logoPath]="logoPath" [isProductLogo]="isProductLogo" [buttonText]="buttonText" [header]="header" [hasBtn]="hasBtn" [imagePath]="imagePath"
        [description]="description" [joinChat]="joinChat" [isProductGRCPage]="true">
      </app-hero-section>
    </section>
    <app-expansion-panel-component> </app-expansion-panel-component>

    <div class="product__grc-img-with-text-holder">
      <app-image-with-text [imageUrl]="banner.imageUrl" [imageText]="banner.imageText" [buttonText]="banner.buttonText"
        [routerButton]="banner.routerButton" [subImgUrl]="subImgUrl" [subTitle]="subTitle"
        [isProductsPage]="isProductsPage" [type]="'Services'"></app-image-with-text>
    </div>

    <section class="products__grc-proactive-approach">
      <div class="products__grc-proactive-approach-holder">
        <div class="products__grc-proactive-approach-info">
          <h2 l10nTranslate>Always Audit Ready</h2>
          <p l10nTranslate
            [innerHTML]="'Onboard control owners on one platform for easier collaboration Ensure controls are actively managed and evidence files are continuously refreshed through tasks and workflow automation'">
          </p>
        </div>
        <img *ngIf="currentLanguage == 'en'" src="../../../../assets/images/image18.png" alt="proactive-approach">
        <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/images/image19ar.png" alt="proactive-approach">
      </div>
    </section>

    <section class="grc-page__automation-section">
      <div class="automation-section__container">
        <div class="automation-section__section-one">
          <span l10nTranslate [innerHTML]="'Extend automation and connect your enterprise applications'"></span>
        </div>
        <div class="automation-section__section-tow">
          <div class="automation-section__child">
            <img src="../../../../assets/images/yellow1.svg" alt="" />
            <img src="../../../../assets/images/yellow2.svg" alt="" />
            <img src="../../../../assets/images/yellow3.svg" alt="" />
            <img src="../../../../assets/svg/splunk-logo-dark.svg" alt="" />
          </div>
          <div class="automation-section__child">
            <img src="../../../../assets/images/yellow4.svg" alt="" />
            <img src="../../../../assets/images/yellow5.svg" alt="" />
            <img src="../../../../assets/images/yellow6.svg" alt="" />
          </div>
        </div>
      </div>
    </section>

    <app-major-frameworks> </app-major-frameworks>

    <section class="products-grc__section-nine">
      <div>
        <h2 [innerHTML]="'Manage cybersecurity and other regulations in various fields through one platform'" l10nTranslate></h2>
        <h5 l10nTranslate>This will enable your organization to deal with a unified platform for governance, risk, and compliance management, and to activate the integration between various departments and domains</h5>
      </div>
      <div class="section-nine__cards">
        <ng-container *ngFor="let item of sectionNine">
          <div class="section-nine__container-card">
            <img src="{{ item?.imagePath }}" />
            <div class="section-nine__card-description" l10nTranslate>
              {{ item?.title }}
            </div>
          </div>
        </ng-container>
      </div>
    </section>

    <div class="grc-Platform__-future-section">
      <app-feature-section>
      </app-feature-section>
    </div>

    <section class="grc-Platform">
      <div class="grc-Platform__container">
        <h2 l10nTranslate>Lunch Your Modern GRC Platform in Few Weeks</h2>
        <h6 l10nTranslate>We apply carefully designed onboarding process to ensure fast platform deployment</h6>
        <div class="grc-Platform__circel-container">
          <!-- <div class="grc-Platform__circel-card-col"> -->
            <div l10nTranslate class="grc-Platform__circel-card">Discovery Sessions</div><span class="grc-Platform__line">------</span>
            <div l10nTranslate class="grc-Platform__circel-card">Platform Deployment</div><span class="grc-Platform__line">------</span>
          <!-- </div> -->
          <!-- <div class="grc-Platform__circel-card-col"> -->
            <div l10nTranslate class="grc-Platform__circel-card">Data Migration</div><span class="grc-Platform__line">------</span>
            <div l10nTranslate class="grc-Platform__circel-card">Knowledge Transfer</div>
          <!-- </div> -->
        </div>
      </div>
    </section>
  </div>
</div>